export default function ($http) {
    return function (task) {
        return $http.put(`api/tasks/${task.id}/takeOverOwnership`);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/tasks/takeOverTaskOwnership.js